var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex flex-row items-center justify-center p-2 text-white font-bold gap-2 bg-blue-600 hover:bg-blue-500 rounded-md",attrs:{"href":"https://www.facebook.com/profile.php?id=61571867391709","target":"_blank","rel":"noopener noreferrer","aria-label":"Facebook messenger"}},[_c('i',{staticClass:"bi bi-facebook text-xl"}),_vm._v("Facebook Messenger\n")])
}]

export { render, staticRenderFns }